// extracted by mini-css-extract-plugin
module.exports = {"nlr-card":"Card_nlr-card__Xr5Xx","date-box":"Card_date-box__3g-KY","name":"Card_name__16N_W","img-box":"Card_img-box__4kFVX"};